module.exports = require("/codebuild/output/src4162575756/src/phx-global-form-gatsby/src/gatsby/gatsby-browser.ts");